import styled from "@emotion/styled";
import { EventPresenter, eventPresenterClasses } from "@kaltura/mediaspace-shared-event-platform-event-list";
import { Box } from "@kaltura/mediaspace-shared-styled";

export const StyledPresenterContainer = styled(Box)(({ theme }) => ({
    "& > a": {
        textDecoration: "none",
        display: "block",
    },
    "& > div > a": {
        textDecoration: "none",
    },
}));

export const StyledPresenter = styled(EventPresenter)(({ theme }) => ({
    [`.${eventPresenterClasses.details}`]: {
        marginTop: "auto",
        marginBottom: "auto",
    },
}));
